import {Component, Vue} from 'vue-facing-decorator';



@Component({
    name: 'app-global-search',
})
export default class GlobalSearch extends Vue {

    get app_base_data(): any {
        return this.$store.state.baseData;
    }
}